import CustomInput from "../../shared/CustomInput";
import BorrowerApplication from "../../shared/BorrowerApplication";

const NextOfKin = ({
  closeKinInformation,
  activeIndex,
  handleNextStep,
  kinDetails,
  setKinDetails,
  loading,
  handleBack,
  isDisabled = true,
}) => {
  return (
    <BorrowerApplication
      closeBioInformation={closeKinInformation}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      loading={loading}
      handleBack={handleBack}
      isDisabled={isDisabled}
    >
      <p className="text-[#000000] font-normal text-[14px]">
        Create a Borrower
      </p>
      <p className="text-[#000000] font-semibold text-[20px]">
        Borrower’s Next of Kin
      </p>
      <p className="text-[#5C5C5C] text-[14px] font-normal">
        Enter next of kin details of the borrower
      </p>
      <div className="flex items-center gap-[20px] my-[10px]">
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="Full Name"
          >
            Full Name
          </label>
          <CustomInput
            placeholder="Enter your name"
            type="text"
            value={kinDetails?.name}
            onChange={(e) =>
              setKinDetails({
                ...kinDetails,
                name: e.target.value,
              })
            }
          />
        </div>
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="Relationship"
          >
            Relationship
          </label>
          <CustomInput
            placeholder="Enter your relationship"
            type="text"
            value={kinDetails?.relationship}
            onChange={(e) =>
              setKinDetails({
                ...kinDetails,
                relationship: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="flex items-center gap-[20px] my-[10px]">
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="Phone Number"
          >
            Phone Number
          </label>
          <CustomInput
            placeholder="Enter phone number"
            type="text"
            value={kinDetails?.phoneNumber}
            onChange={(e) =>
              setKinDetails({
                ...kinDetails,
                phoneNumber: e.target.value,
              })
            }
          />
        </div>
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="residence"
          >
            Residence
          </label>
          <CustomInput
            placeholder="Enter residence"
            type="text"
            value={kinDetails?.location}
            onChange={(e) =>
              setKinDetails({
                ...kinDetails,
                location: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="flex items-center gap-[20px] my-[20px]">
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="Nearest Landmark"
          >
            Nearest Landmark
          </label>
          <CustomInput
            placeholder="Enter landmark"
            type="text"
            value={kinDetails?.location}
            onChange={(e) =>
              setKinDetails({
                ...kinDetails,
                location: e.target.value,
              })
            }
          />
        </div>
      </div>
    </BorrowerApplication>
  );
};

export default NextOfKin;
